export default __webpack_public_path__ + "static/google-play-badge-92c1cf0382421aaa4beae82633b74c35.png";